export const RESET_PASSWORD_PATH = '/v1/security/user/password/reset';
export const REQUEST_TOKEN_PATH = '/v1/security/user/password/requesttoken';
